<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <g clip-path="url(#clip0_622_2416)">
      <path
        d="M28.0054 4.15178L8.0541 2.75665C6.55663 2.65194 5.07914 3.14682 3.94622 4.13165C2.81331 5.11648 2.11761 6.51072 2.0129 8.00818L1.03631 21.9741C0.931594 23.4716 1.42648 24.949 2.41131 26.082C3.39614 27.2149 4.79038 27.9106 6.28784 28.0153L8.63757 28.1796C8.46277 29.2441 8.77903 30.359 9.48741 31.1739C10.1242 31.9065 11.0259 32.3564 11.9942 32.4241L19.9747 32.9821C20.943 33.0498 21.8985 32.7298 22.6311 32.093C23.446 31.3846 23.9143 30.3246 23.8894 29.2461L26.2391 29.4104C27.7366 29.5151 29.2141 29.0202 30.347 28.0354C31.4799 27.0506 32.1756 25.6563 32.2803 24.1589L33.2696 9.91291C33.2981 8.5124 32.8053 7.14731 31.8819 6.0851C30.8971 4.95219 29.5028 4.25649 28.0054 4.15178Z"
        fill="white"
      />
      <path
        d="M21.2279 29.3966C21.2094 29.6612 21.0865 29.9076 20.8864 30.0816C20.6862 30.2556 20.4251 30.3429 20.1605 30.3244L12.18 29.7664C11.9155 29.7479 11.6691 29.625 11.4951 29.4249C11.3211 29.2247 11.2337 28.9636 11.2522 28.699C11.2707 28.4345 11.3936 28.1881 11.5937 28.0141C11.7939 27.8401 12.055 27.7527 12.3195 27.7712L20.3001 28.3293C20.5646 28.3478 20.811 28.4706 20.985 28.6708C21.159 28.871 21.2464 29.132 21.2279 29.3966ZM30.6035 10.0034L29.6269 23.9693C29.5714 24.763 29.2029 25.5021 28.6024 26.0241C28.0019 26.5461 27.2187 26.8082 26.425 26.7527L6.47368 25.3576C5.67997 25.3021 4.94081 24.9335 4.41882 24.3331C3.89682 23.7326 3.63475 22.9493 3.69025 22.1556L4.66684 8.18971C4.72235 7.396 5.09088 6.65685 5.69136 6.13485C6.29184 5.61286 7.07509 5.35079 7.86881 5.40629L27.8201 6.80142C28.6138 6.85692 29.353 7.22545 29.8749 7.82594C30.3969 8.42642 30.659 9.20967 30.6035 10.0034ZM21.6359 16.3934C21.6471 16.2331 21.6195 16.0725 21.5554 15.9251C21.4913 15.7778 21.3927 15.6481 21.2678 15.5469L16.5241 11.7067C16.382 11.5915 16.211 11.5175 16.0297 11.4928C15.8485 11.4681 15.6639 11.4936 15.4961 11.5665C15.3284 11.6394 15.1838 11.7569 15.0782 11.9063C14.9726 12.0557 14.9099 12.2311 14.8971 12.4136L14.4088 19.3966C14.3961 19.5791 14.4337 19.7616 14.5175 19.9242C14.6013 20.0868 14.7281 20.2233 14.8841 20.3188C15.0401 20.4144 15.2193 20.4653 15.4023 20.466C15.5852 20.4668 15.7648 20.4174 15.9216 20.3231L21.1536 17.1804C21.2913 17.0976 21.407 16.9829 21.491 16.8459C21.575 16.7089 21.6247 16.5537 21.6359 16.3934Z"
        fill="#F2A91E"
      />
    </g>
    <defs>
      <clipPath id="clip0_622_2416">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(2.23221) rotate(4)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
